module.exports = __webpack_public_path__ + "staticcomp/img/share.57746e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/15/share.jpg
// module id = i6e1
// module chunks = 39